export type GroupShape = "circle" | "square" | "triangle" | "star" | "diamond";

interface GroupShapeIconProps {
  shape: GroupShape;
  color: string;
  size?: number;
  filled?: boolean;
}

export function GroupShapeIcon({
  shape,
  color,
  size = 18,
  filled = true,
}: GroupShapeIconProps) {
  const commonProps = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: filled ? color : "none",
    stroke: "#202020",
    strokeWidth: filled ? 0 : 2,
  };

  switch (shape) {
    case "circle":
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="10" />
        </svg>
      );
    case "square":
      return (
        <svg {...commonProps}>
          <rect x="4" y="4" width="16" height="16" rx="2" />
        </svg>
      );
    case "triangle":
      return (
        <svg {...commonProps}>
          <path d="M12 2 L22 20 L2 20 Z" />
        </svg>
      );
    case "star":
      return (
        <svg {...commonProps}>
          <path d="M12 2 L15.09 8.26 L22 9.27 L17 14.14 L18.18 21.02 L12 17.77 L5.82 21.02 L7 14.14 L2 9.27 L8.91 8.26 Z" />
        </svg>
      );
    case "diamond":
      return (
        <svg {...commonProps}>
          <path d="M12 2 L22 12 L12 22 L2 12 Z" />
        </svg>
      );
    default:
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="10" />
        </svg>
      );
  }
}
